
import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useStore} from '@nanostores/react';
import * as _ from "lodash";


import * as C from "../../controls/constraints.jsx";
import { PlainTextWidget } from "../../controls/widgets.jsx";

import Schema from '../../stores/Schema.jsx';

import { $currentFlags, $currentState, clearSavedState, postState } from '../../stores/State.jsx';


function splitFullName(name) {
    return _.split(name, /\s+/g, 3);
}



const SpecializationListItem = ({...props}) => {
    const
        specialization = props.specialization,
        hasSpecialization = typeof specialization !== 'undefined' && specialization !== null;

    if(!hasSpecialization) return <div>&nbsp;</div>;

    const
        isSpo = specialization.level === 'spo',
        isNpo = specialization.level === 'npo';

    return (
        <span>
            {(isSpo)
                ? (
                    <span className="trit-value-field">&hellip;подготовки специалистов среднего звена по специальности {specialization.id} &laquo;
                        <a href={specialization.url} target="_blank">{specialization.title}</a>&raquo;</span>
                )
                : null
            }
            {(isNpo)
                ? (
                    <span className="trit-value-field">&hellip;подготовки квалифицированных рабочих (служащих) по профессии {specialization.id} &laquo;
                        <a href={specialization.url} target="_blank">{specialization.title}</a>&raquo;</span>
                )
                : null
            }
            со сроком обучения <span className="trit-value-field">{specialization.duration}</span>
        </span>
    );

}

const StatementWidget = ({schema, data}) => {
    const 
        me = this,
        navigate = useNavigate(),
        //
        representatives = _.map(data.representatives, function(v) {
            let fn = splitFullName(v.full_name);
            return _.extend({}, v, {
                'last_name': fn[0],
                'first_name': fn[1],
                'middle_name': fn[2]
            });
        }),
        specialization = data.specialization,
        hasSpecialization = typeof data.specialization != 'undefined' && data.specialization.length,
        prio_subjects = data.education_prio_subjects || [];

    return (
        <form className="form">
            <div className="card border-default">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-8">
                            № {data._document_uid || "_____"}
                        </div>
                    </div>
                    <br />

                    <div className="row">
                        <div className="col-md-9">
                            <table className="trit-table-hr">
                                <tbody>
                                <tr><th>ФИО:</th><td><PlainTextWidget name="full_name" data={data} schema={schema} onClick={navigate.bind(me, '/')} /></td></tr>
                                <tr><th>Дата рождения:</th><td><PlainTextWidget name="birth_date" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                <tr><th>Место рождения:</th><td><PlainTextWidget name="birth_place" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                </tbody>

                                {(data.document_type == 'Паспорт гражданина РФ') ?
                                (<tbody>
                                    <tr><th>Гражданство:</th><td><PlainTextWidget name="citizenship" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                    <tr><th>Паспорт:</th><td><PlainTextWidget name="passport_no" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                    <tr>
                                        <th>Выдан:</th>
                                        <td className="text-justify"><PlainTextWidget name="passport_issued_by" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <td><PlainTextWidget inline name="passport_issued_at" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} />, код подразделения <PlainTextWidget inline name="passport_code" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td>
                                    </tr>
                                    </tbody>)
                                    :
                                    (<tbody>
                                    <tr><th>Гражданство:</th><td><PlainTextWidget name="citizenship" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                    <tr><th>Удостоверение личности:</th><td className="text-justify"><PlainTextWidget name="document_description" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                    </tbody>)
                                }

                                <tbody>
                                <tr><th>ИНН:</th><td><PlainTextWidget name="tax_id" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                <tr><th>СНИЛС:</th><td><PlainTextWidget name="ssn_id" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                </tbody>

                                <tbody>
                                <tr><th>Адрес регистрации:</th><td><PlainTextWidget name="address_reg" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                <tr><th>Адрес проживания:</th><td><PlainTextWidget name="address_living" data={data} schema={schema} onClick={navigate.bind(me, '/docs')} /></td></tr>
                                </tbody>

                                <tbody>
                                <tr><th>Контактный телефон:</th><td><PlainTextWidget name="contact_phone" data={data} schema={schema} onClick={navigate.bind(me, '/contacts')} /></td></tr>
                                <tr><th>Домашний телефон:</th><td><PlainTextWidget name="contact_phone_alt" data={data} schema={schema} onClick={navigate.bind(me, '/contacts')} /></td></tr>
                                <tr><th>Электронная почта:</th><td><PlainTextWidget name="contact_email" data={data} schema={schema} href={"mailto:" + data.contact_email} onClick={navigate.bind(me, '/contacts')} /></td></tr>
                                <tr><th>Страница в соцсети:</th><td><PlainTextWidget name="contact_social" data={data} schema={schema} href={data.contact_social} onClick={navigate.bind(me, '/contacts')}/></td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <h3>З А Я В Л Е Н И Е</h3>

                            <div className="trit-clickable" onClick={navigate.bind(me, '/')}>
                                <p>Прошу принять меня на обучение в очной форме по основной профессиональной образовательной программе&hellip;</p>
                                <ul>
                                {(hasSpecialization)
                                    ? _.map(specialization, (v, k) => <li key={k}><SpecializationListItem specialization={v} /></li>)
                                    : <li><span className="text-danger" onClick={navigate.bind(me, '/')}>Не указано направление подготовки</span></li>
                                }
                                </ul>
                                <p>Возможность зачисления на обучение по указанным программам прошу рассматривать в порядке убывания приоритета.</p>
                            </div>

                            <div className="trit-section">
                                <div className="trit-section-hdr">
                                    <p>О себе сообщаю следующее:</p>
                                </div>
                                <div className="trit-section-content trit-clickable" onClick={navigate.bind(me, '/education')}>
                                    {(data.education_document_type)
                                        ? (
                                            <span>
                                                Основное общее образование: <PlainTextWidget inline name="education_org" data={data} schema={schema} />, окончено
                                                в <PlainTextWidget inline name="education_finished_at" data={data} schema={schema} /> году.

                                                Выдан <PlainTextWidget inline name="education_document_type_display" data={data} schema={schema}/>&nbsp;{data.education_document_red? <span>с отличием</span> : null}
                                                &nbsp;<PlainTextWidget inline name="education_document_number" data={data} schema={schema}>№&nbsp;</PlainTextWidget> от&nbsp;<PlainTextWidget inline name="education_document_issue_date" data={data} schema={schema} />
                                            </span>
                                        )
                                        : (
                                            <span className="text-danger" onClick={navigate.bind(me, '/education')}>Не указана информация об образовании</span>
                                        )
                                    }
                                </div>

                                <div className="trit-clickable" onClick={navigate.bind(me, '/education')}>
                                    <span className="trit-section-hdr">Изучаемые иностранные языки:</span>
                                    <span className="trit-section-content">
                                    {(data.education_languages_display && data.education_languages_display.length)
                                        ? (_.map(data.education_languages_display, function(v, k){
                                            return (<span className="label label-success" key={k}>{v}</span>);
                                        })
                                        )
                                        : (
                                            <span className="text-danger"> отсутствуют</span>
                                        )
                                    }
                                    </span>
                                </div>
                            </div>

                            <div className="trit-section trit-clickable" onClick={navigate.bind(me, '/education')}>
                                <div className="trit-section-hdr">Информация об успеваемости:</div>

                                <table className="trit-table-hc">
                                    <thead>
                                        <tr>
                                            <th colSpan={prio_subjects.length + 1}>Приоритетные предметы</th>
                                            <th rowSpan="2">Средний балл аттестата</th>
                                        </tr>
                                        <tr>
                                            {_.map(prio_subjects, function(v, k){
                                                return(
                                                    <th key={k}>{v.title}</th>
                                                );
                                            })}
                                            <th>
                                                Сумма баллов
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            {_.map(prio_subjects, function(v, k){
                                                return(
                                                    <td key={k}>
                                                        <PlainTextWidget
                                                            name={"education_prio_subjects[" + k + "].value"}
                                                            validators={schema.child('education_prio_subjects', v, data).child('value', v, data)}
                                                            value={v.value} />
                                                    </td>
                                                );
                                            })}
                                            <td>
                                                <PlainTextWidget name="education_prio_subject_sum" data={data} schema={schema} />
                                            </td>
                                            <td>
                                                <PlainTextWidget name="education_avg_grade" data={data} schema={schema} />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <br />

                            <div className="trit-section trit-clickable" onClick={navigate.bind(me, '/more')}>
                                <div className="trit-section-hdr">Медицинская группа по физической культуре:</div>
                                <div className="trit-section-content">
                                    <PlainTextWidget inline name="health_group" data={data} schema={schema} />
                                </div>

                                <div className="trit-section-hdr">Особые статусы:</div>
                                <div className="trit-section-content">
                                    {(data.special_status_display && data.special_status_display.length)
                                        ? _.map(data.special_status_display, function(v, k) {
                                            return (<span key={k} className="label label-primary">{v}</span>);
                                        }) : (
                                            <span> отсутствуют</span>
                                        )
                                    }
                                </div>

                                <div className="trit-section-hdr">Дополнительная информация:</div>
                                <div className="trit-section-content">
                                    <PlainTextWidget inline name="additional_info" data={data} schema={schema} />
                                </div>
                            </div>

                            <div className="trit-section trit-clickable" onClick={navigate.bind(me, '/more')}>
                                {(data.is_first_po === true) ? (<span>Профессиональное образование получаю впервые</span> ) : null}
                                {(data.is_first_po === false) ? (<span>Профессиональное образование получаю повторно</span>) : null}
                            </div>

                            <div className="trit-section trit-clickable" onClick={navigate.bind(me, '/parents')}>
                                <div className="trit-section-hdr">Сведения о родителях (законных представителях):</div>
                                <table className="trit-table-hc">
                                    <tbody>
                                        <tr>
                                            <th width="10%">&nbsp;</th>
                                            <th width="30%">Мать</th>
                                            <th width="30%">Отец</th>
                                            <th width="30%">Лица, их заменяющие<br /><small>(законные представители, опекуны, попечители, усыновители)</small></th>
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Фамилия:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.last_name}</td>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Имя:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.first_name}</td>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Отчество:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.middle_name}</td>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Домашний адрес:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.address_living}</td>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Место работы:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.work_organization}</td>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Должность:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.work_position}</td>
                                                );
                                            })}
                                        </tr>
                                        <tr>
                                            <th className="right text-nowrap">Контактные телефоны:</th>
                                            {_.map(representatives, function(v, k){
                                                return (
                                                    <td key={k}>{v.contact_phone}</td>
                                                );
                                            })}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>
    );

}

const ValidationStatusWidget = ({vStatus}) => (
    (vStatus.r === false) ? (
        <div className="no-print alert alert-danger">
            <i className="glyphicon glyphicon-warning-sign" /> Похоже, что некоторые поля ({vStatus.invalid} шт.)
            заполнены некорректно. Пожалуйста, вернитесь и проверьте введённые данные.
        </div>
    ) : (
        <div className="no-print alert alert-warning text-center">
            Пожалуйста, <strong>проверьте введённую информацию</strong>.<br />
            Если всё правильно, нажмите кнопку <strong>&laquo;Отправить заявление&raquo;</strong> внизу страницы
            для передачи документа в приёмную комиссию техникума.
        </div>
    )
)

const NavigationWidget = ({isSent, vStatus, onDataPostRequested}) => (
    <div className="text-center mt-2">
    {(!isSent)
        ? (
            <Link to="/" className="btn btn-secondary">
                <i className="bi bi-chevron-left" /> Вернуться к редактированию
            </Link>

        ) : null
    }

    &nbsp;

    {(vStatus.r !== false)
        ? (
            <button type="button" className="btn btn-success"
                    onClick={onDataPostRequested}>
                <i className="bi bi-ok" /> Отправить заявление
            </button>
        ) : null
    }
    </div>
)

export default () => {
    const
        navigate = useNavigate(),
        //
        schema = Schema,
        data = useStore($currentState),
        //
        flags = useStore($currentFlags),
        isSent = flags.isSent,
        //
        vStatus = C.validateSchema(data, schema),
        //
        [sendProgress, setSendProgress] = useState(null);

    const
        onDataPostRequested = () => {
            setSendProgress(false);

            postState()
            .then((remoteId) => {
                setSendProgress(true);
                clearSavedState();
                navigate('/status/' + remoteId);

            }, (err) => {
                console.log('bad', err);
                setSendProgress(err);
                
            })
        }
    
    if(_.isObject(sendProgress)){
        return (
            <div className="card border-danger">
                <div className="card-header text-bg-danger">
                    Ошибка при отправке заявления
                </div>
                <div className="card-body text-center">
                    <div className="m-2">
                        <i className="bi bi-envelope-x" style={{"fontSize":"400%"}} />
                    </div>
                    <div>Ваше заявление не удалось отправить в информационную систему техникума.</div>
                    <div className="text-danger"><strong>Ошибка:</strong> {sendProgress.message}</div>
                </div>
                <div className="card-footer">
                    <button type="button" className="btn btn-danger" onClick={onDataPostRequested}>
                            Повторить отправку
                            <i className="bi bi-chevron-double-right" /> 
                    </button>
                </div>
            </div>            
        );
    }
    if(sendProgress == false) {
        return(
        <div className="card border-warning">
            <div className="card-header text-bg-warning">
                Отправка заявления
            </div>
            <div className="card-body text-center">
                <div className="spinner-border spinner-border-lg m-2" role="status">
                    <span className="visually-hidden">Загрузка...</span>
                </div>
                <div>В данный момент идёт процесс отправки вашего заявления. Это может занять некоторое время.</div>
            </div>

        </div>
        );
    }
    if(sendProgress == true) {
        return(
        <div className="card border-success">
            <div className="card-header text-bg-success">
                Отправка заявления
            </div>
            <div className="card-body text-center">
                <div className="m-2"><i className="bi bi-envelope-check" style={{"fontSize":"400%"}} /></div>
                <div>Заявление успешно отправлено</div>
            </div>
        </div>
        );
    }


    return (
        <div className="form">
            <ValidationStatusWidget vStatus={vStatus} />

            <StatementWidget schema={schema} data={data} />

            <div className="text-center">
                <NavigationWidget isSent={isSent} vStatus={vStatus} onDataPostRequested={onDataPostRequested} />
            </div>

        </div>
    );

}
